export default __webpack_public_path__ + "static/media/vanaja-dr.1a5374b6.png";